import React from "react";
import styled from "styled-components";
import { Button, ButtonProps } from "../common-ui/components/button/Button";

const StyledButton = styled(Button).withConfig({
  shouldForwardProp: (prop) => !["isHero", "hasHeroHeight"].includes(prop),
}) <ButtonProps>`
  font-size: 24px;
  height: 48px;
`;

export type SummitScreenButtonProps = Omit<
  ButtonProps,
  "isHero" | "hasHeroHeight" | "size"
>;

const SummitScreenButton: React.FC<SummitScreenButtonProps> = (props) => (
  <StyledButton {...props} />
);

export { SummitScreenButton };
